import { HashRouter } from 'react-router-dom'
import ToolRouter from './routes/ToolRouter'

function App() {
  return (
    <HashRouter>
      <div className="min-h-screen bg-gray-50">
        <ToolRouter />
      </div>
    </HashRouter>
  )
}

export default App